<mat-icon (click)="toggle()" [color]="color" [fontIcon]="icon" [fontSet]="fontSet"></mat-icon>
